export enum LayoutType {
  DASHBOARDV1 = 'dashboardv1',
  DEFAULTV1 = 'defaultv1_layout',
  BLANKLAYOUTV1 = 'blank_layoutv1',
}
